module.exports = __webpack_public_path__ + "static/hybrid-slider-9d5438fabba04f27fe40553b13b8b269.png";